import Image, { StaticImageData } from 'next/image'
import quotes from '../images/quotes.svg'
import { CompanyLogo } from './CompanyLogo'

interface Author {
  name: string
  role: string
  image: StaticImageData
}

interface TestimonialProps {
  review: string
  person: {
    author: Author
  }
  company:
    | 'intercom'
    | 'vimeo'
    | 'cargurus'
    | 'noths'
    | 'beautyPie'
    | 'chiliPiper'
    | 'substack'
    | 'clickUp'
    | 'clair'
    | 'software'
    | 'videoAmp'
    | 'tmm'
    | 'heap'
    | 'tails'
    | 'upEquity'
    | 'flipsideCrypto'
    | 'super'
    | 'tails-2'
    | 'goPuff'
}

export default function FeaturesTestimonial({
  review,
  person,
  company,
}: TestimonialProps) {
  const parts = review.split('<>')

  const formattedReview = parts.map((part, i) =>
    i % 2 === 1 ? (
      <span key={i} className="pl-[5px] font-semibold text-[#38BDF9CC]">
        {part}
      </span>
    ) : (
      part
    )
  )

  return (
    <section className="flex w-full items-center justify-center px-5 py-16 sm:px-10 xl:px-[100px]">
      <div className="flex w-full flex-col items-center justify-center gap-10 px-8 xl:flex-row xl:gap-[88px]">
        <div className="relative w-full xl:w-[592px]">
          <Image
            src={quotes as string}
            alt="quotes"
            className="absolute left-[-33px] top-[-25px] w-[55.682px] xl:w-auto"
          />
          <p className="text-xl !leading-[150%] tracking-[-0.2px] text-white/80">
            {formattedReview}
          </p>
        </div>

        <div className="shadow-testimonial flex h-auto w-full md:min-w-[320px] flex-col items-start justify-between gap-[30px] rounded-[10px] border border-[#1C1D29] bg-[#131422] p-4 pr-7 lg:w-auto xl:h-[154px] xl:gap-0">
          <div className="flex items-start gap-4 xl:items-center">
            <div className="h-16 w-16 overflow-hidden rounded-[6px] bg-slate-50">
              <Image
                className="h-16 w-16 object-cover"
                src={person.author.image}
                unoptimized
                alt=""
                width={56}
                height={56}
              />
            </div>
            <div className="flex flex-col">
              <h4 className="text-xl font-semibold leading-[150%] tracking-[-0.2px]">
                {person.author.name}
              </h4>
              <h5 className="text-lg leading-[150%] tracking-[-0.18px] text-white/80">
                {person.author.role}
              </h5>
            </div>
          </div>
          <CompanyLogo name={company} />
        </div>
      </div>
    </section>
  )
}
